import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import Support from '../components/support/Support';
import Footer from '../components/footer/Footer';

const SupportPage = () => {

    const { isSideNavOpen } = useContext(SideNavContext);

    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <Support />
            </main>

            <Footer />

            <TopButton />
        </>
    );
};

export default SupportPage;